export enum LayoutElementType {
    Box                 = 1,
    Icon                = 2,
    MenuButton          = 3,
    TaskField           = 100,
}
